import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { INotify, INotifyGet, STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const {
  NOTIFICATIONS,
  NOTIFY_DEL_RESPONSE,
  NOTIFY_ADD_EDT_RESPONSE,
  NOTIFY_REPLAY_RESPONSE,
  LOADER_IDENTIFIER,
  ALL_ROLES,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_NOTIFICATIONS_SUCCESS]: (state: any, action: any) => {
    let notify: INotify[] = [];
    action.payload.messages.forEach((el: INotifyGet) =>
      notify.push({
        uniqueId: el.id,
        title: el.title,
        message: el.message,
        startDate: el.startDate,
        roleList: el.roles.join(", "),
      })
    );
    let data = {
      pageNumber: action.payload.pageNumber,
      totalElements: action.payload.totalElements,
      pageTotalNumber: action.payload.pageTotalNumber,
      pageSize: action.payload.pageSize,
      messages: notify,
    };
    return immutableSet([NOTIFICATIONS], data, state);
  },
  [actionTypes.GET_NOTIFICATIONS_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFICATIONS], [], state),

  [actionTypes.DEL_NOTIFY]: (state: any, action: any) =>
    immutableSet([NOTIFY_DEL_RESPONSE], IResponseState.PENDING, state),
  [actionTypes.DEL_NOTIFY_SUCCESS]: (state: any, action: any) =>
    immutableSet([NOTIFY_DEL_RESPONSE], IResponseState.SUCCESS, state),
  [actionTypes.DEL_NOTIFY_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFY_DEL_RESPONSE], IResponseState.ERROR, state),

  [actionTypes.SEND_NOTIFY]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.PENDING, state),
  [actionTypes.SEND_NOTIFY_SUCCESS]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.SUCCESS, state),
  [actionTypes.SEND_NOTIFY_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.ERROR, state),

  [actionTypes.UPDATE_NOTIFY]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.PENDING, state),
  [actionTypes.UPDATE_NOTIFY_SUCCESS]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.SUCCESS, state),
  [actionTypes.UPDATE_NOTIFY_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFY_ADD_EDT_RESPONSE], IResponseState.ERROR, state),

  [actionTypes.REPLAY_NOTIFY]: (state: any, action: any) =>
    immutableSet([NOTIFY_REPLAY_RESPONSE], IResponseState.PENDING, state),
  [actionTypes.REPLAY_NOTIFY_SUCCESS]: (state: any, action: any) =>
    immutableSet([NOTIFY_REPLAY_RESPONSE], IResponseState.SUCCESS, state),
  [actionTypes.REPLAY_NOTIFY_FAILURE]: (state: any, action: any) =>
    immutableSet([NOTIFY_REPLAY_RESPONSE], IResponseState.ERROR, state),

  [actionTypes.NOTIFY_GET_ALL_ROLES_SUCCESS]: (state: any, action: any) =>
    immutableSet([ALL_ROLES], action.payload.roles, state),
  [actionTypes.NOTIFY_GET_ALL_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet([ALL_ROLES], [], state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
